import { uapiFetcher } from 'util/UAPI';
import { YieldData } from './types';
import { FIELD_YIELD_DATA_QUERY } from './query';
import { trackError } from 'util/error';

export const fetchYieldData = async (fieldUuid: string, cropId: string) => {
  try {
    return await uapiFetcher<YieldData>(FIELD_YIELD_DATA_QUERY, { id: fieldUuid, cropId });
  } catch (error) {
    trackError(new TypeError('Could not fetch "GetFieldYieldData" query from UAPI'), { error });
    throw error;
  }
};
